import { LocalStorageConsts } from 'client/util/Constants';
import { LoginModal, LoginModalConfig } from 'client/components/Modal/LoginModalTypes';
import LocalStorageService from 'client/util/LocalStorageService';
import LoginModalTesting from 'client/components/Modal/LoginModalTesting.vue';
import ReportsAnnouncement from 'client/Reports/ReportsAnnouncement.vue';

const { getValue } = LocalStorageService;
const {
  reportsAnnouncementSeen,
  loginModalTesting,
  loginModalTestingSeen,
} = LocalStorageConsts;

// Leaving comments for use as an example for modal configs and export

// const welcomeModalConfig = (config) => {
//   const { onboardingFlowComplete } = config;
//
//   return new LoginModalConfig({
//     name: 'welcomeModal',
//     component: WelcomeModal,
//     localStorageKey: welcomeModalSeen,
//     modalVisibility: () => false,
//     preventCloseOnOverlayClick: true,
//     isLargeModal: true,
//   });
// }

// Do not delete reportsAnnouncementModalConfig.
// This feature has not been released yet, waiting on release date.

// eslint-disable-next-line
const reportsAnnouncementModalConfig = (config) => {
  const { onboardingFlowComplete } = config;
  return new LoginModalConfig({
    name: 'reportsAnnouncement',
    component: ReportsAnnouncement,
    localStorageKey: reportsAnnouncementSeen,
    modalVisibility: () => onboardingFlowComplete,
    isLargeModal: true,
    preventCloseOnOverlayClick: true,
    startDate: '',
    endDate: '',
  });
};

const showLoginModalTesting = getValue(loginModalTesting);
const testingModalConfig = new LoginModalConfig({
  name: 'testingModal',
  component: LoginModalTesting,
  localStorageKey: loginModalTestingSeen,
  preventCloseOnOverlayClick: true,
  modalVisibility: () => showLoginModalTesting,
});

/**
 * @type {Array<LoginModal>}
 *
 * The list of modal configs in the order they should appear
 * Note: Only the first two eligible modals (including the Welcome Modal
 * and/or Signup Question Modal on first login) will appear at a time
 *
 * Example:
 * export default function modalConfigs(config = {}) {
 *   return [
 *     new LoginModal(welcomeModalConfig(config)),
 *   ];
 * }
 * */

export default function modalConfigs() {
  return [
    new LoginModal(testingModalConfig),
  ];
}
